
export default {
  name: "ThePopover",
  props: {
    block: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      isOpen: false,
      openMethod: null
    }
  },
  methods: {
    handleMouseLeave(event) {
      if (this.openMethod === 'click') return
      if (!this.$refs.content.contains(event.relatedTarget) && !event.relatedTarget.classList.contains('tooltip')) {
        this.close()
      }
    },
    handleMouseFromContentLeave(event) {
      if (this.openMethod === 'click') return
      if (!this.$refs.trigger.contains(event.relatedTarget)) {
        this.close()
      }
    },
    handleMousedown() {
      if (this.openMethod === 'click') {
        this.isOpen ? this.close() : this.open()
        return
      }
      if (this.openMethod === 'hover') {
        this.openMethod = 'click'
      }
    },
    handleMouseEnter(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.openMethod === 'click') return
      this.open()
      this.openMethod = 'hover'
    },
    close() {
      this.openMethod = null
      this.isOpen = false
    },
    open() {
      this.isOpen = true
    },
    globalClickHandler(event) {
      if (!this.$refs.trigger.contains(event.target) && !this.$refs.content.contains(event.target)) {
        this.close()
      }
    }
  },
  mounted() {
    document.body.addEventListener('click', this.globalClickHandler)
  },
  destroyed() {
    document.body.removeEventListener('click', this.globalClickHandler)
  }
}
